<template>
  <div class="Dialog error" v-if="isBusyShown" >
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld"></div>
      <div class="pic-cloud"></div>

      <div class="title">
        <span v-if="state.matches('task.exception.expired')">
          活动已结束
        </span>
        <span v-else>温馨提示</span>
      </div>

      <div class="inner-body">

        <p class="content" v-if="state.matches('task.exception.expired')">
          您可以关注“腾讯充值”公众号，后续活动将会通过公众号通知您</p>
        <p class="content" v-if="isBusyCountDownShown">当前活动太火爆，网络堵车啦！正在
          排队进入.....{{ state.context.busyCount }}</p>
        <p class="content" v-if="isBusyRetryShown">你前面还有很多召唤师在排队哦， 重试可进入</p>
        <div class="btns">
          <!--<button class="btn">确定</button>-->
          <button class="btn" v-if="isBusyRetryShown" @click="isBusyRetry">重试</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api"
export default {
  name: "BusyDialog",
  props: ["state", "send"],
  setup(props) {
    const isBusyShown = computed(() => {
      return ["task.exception"].some(props.state.matches)
    })

    const isBusyCountDownShown = computed(() => {
      return ["task.exception.countdownStart"].some(props.state.matches)
    })
    const isBusyRetryShown = computed(() => {
      return ["task.exception.countdownEnd"].some(props.state.matches)
    })

    const isBusyRetry = () => {
      location.reload()
    }
    return {
      isBusyShown,
      isBusyCountDownShown,
      isBusyRetry,
      isBusyRetryShown
    }
  }
}
</script>

<style scoped>
</style>
